export default "__VITE_ASSET__5a738581__"